<template>
    <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-lg-10">
            <h2>{{ $t("navigations.cra management") }}</h2>
        </div>
    </div>

    <div class="wrapper wrapper-content">
        <div class="ibox-content mb-1 px-3 py-2"> 
         <div class="form-group mb-1">
          <div class="d-flex flex-column flex-lg-row my-2 my-lg-0 mb-lg-0">
            <div class="form-group mb-lg-0 w-100 pl-lg-0 px-1">
              <label class="mb-0">CRA</label>
              <input type="text" class="form-control my-md-2 my-lg-0" v-model="searchField.cra" />
            </div>
            <!-- <div class="form-group mb-lg-0 w-100 px-1">
              <label class="mb-0">Site Code</label>
               <input type="text" class="form-control my-md-2 my-lg-0" v-model="searchField.siteCode" />
            </div> -->
            <span class="col-sm-12 col-lg-2 save_btn my-1 my-lg-0 mx-lg-1 align-self-end" @click="search()">
              Search
            </span>
          </div>
        </div>
      </div>
        <div class="ibox-body">
            <!-- Header -->
            <div class="ibox-title style_2 d-flex justify-content-between">
                <h5 class="mt-1">CRA List</h5>

                <div class="d-flex">
                    <div class="position-relative align-self-center" :class="{ 'mr-3': craList.length !== 0 }"
                        aria-label="Create CRA" tabindex="0">
                        <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="17"
                            alt="Create CRA" @click="CreateCra()" />
                        <div class="tool-tip">{{ $t("navigations.assign cra") }}</div>
                    </div>
                </div>
            </div>

            <div class="ibox-content">
                <div class="text-center" v-if="showTableLoading">
                    <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
                    <div>
                        {{ $t("navigations.please wait while the list is being loaded") }}
                    </div>
                </div>

                <template v-else>
                    <div class="text-center" v-if="paginatedCraList.length === 0">
                        {{ $t("navigations.no data available") }}
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table table-striped table-bordered dataTables">
                            <thead>
                                <tr>
                                    <th class="sort_block" @click="SortSelected('craId', 1)">
                                        <div class="d-flex justify-content-between">
                                            CRA
                                            <span>
                                                <i class="fa fa-long-arrow-up"></i>
                                                <i class="fa fa-long-arrow-down"></i>
                                            </span>
                                        </div>
                                    </th>

                                    <th>Assigned Sites</th>

                                    <th class="text-center">
                                        {{ $t("navigations.edit") }}
                                    </th>

                                    <th class="text-center">
                                        {{ $t("navigations.delete") }}
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="item in paginatedCraList" :key="item.craId + item.id">
                                    <td>{{ item.craName }}</td>
                                    <td class="text-center">
                                        <i class="fa fa-eye edit-delete cursor-pointer" style="color:#3c4192"
                                            title="View Sites"
                                            @click="openViewSitesModal(item)"></i>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-edit edit-delete" style="color:#a13b7c"
                                            @click="EditCRA(item.id, item.studyId)"></i>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-trash edit-delete" style="color:#a13b7c"
                                            @click="DeleteCra(item.id)"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Pagination -->
                    <div v-if="paginatedCraList.length !== 0" class="row mt-1 mx-0">
                        <div class="col-lg-12 px-0">
                            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
                                <div class="d-flex justify-content-lg-end px-0">
                                    <v-pagination v-model="currentPage" :pages="totalPage" :range-size="1"
                                        active-color="#618bd7" @update:modelValue="loadPage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>

    <!-- View Assigned Sites Modal -->
    <teleport to="#app">
        <div v-if="showViewSitesModal" class="sites_modal__wrapper">
            <div class="sites_modal__container">
                <div class="modal-header py-0 px-2">
                    <h4 class="modal-title">{{ $t("navigations.assigned sites") }}</h4>
                    <div class="cursor-pointer">                   
                        <i class="fa fa-times" title="Close" @click.prevent="closeViewSitesModal()"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <div v-if="!selectedCraForView?.sites || selectedCraForView.sites.length === 0" class="text-center empty-state">
                        <p>{{ $t("navigations.no sites assigned") }}</p>
                    </div>
                    <table v-else class="table sites-table">
                        <thead>
                            <tr>
                                <th>{{ $t("navigations.site code") }}</th>
                                <th>{{ $t("navigations.planned date") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(site, index) in selectedCraForView?.sites" :key="index">
                                <td>{{ site.siteCode }}</td>
                                <td>{{ site.plannedDate ? formatDateDDMMYYYY(site.plannedDate) : '-' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>                
            </div>
        </div>
    </teleport>

    <CraAddEditModal v-if="showCreateCraModal" :isEditMode="editingCraId !== null" :editingId="editingCraId"
        @closeModal="closeCraModal" @saved="refreshCraList" />
</template>

<script src="./CraList.js"></script>
<style scoped>
.position-relative .tool-tip {
    visibility: hidden;
    width: max-content;
    background-color: #616161;
    color: #fff;
    text-align: center;
    border-radius: 0.3em;
    padding: 0.1rem 0.8rem;
    right: 0;
    top: -30px;
    font-size: 0.8rem;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    -webkit-transition: visibility 75ms ease-in;
    transition: visibility 75ms ease-in;
}

.position-relative:hover .tool-tip,
.position-relative:focus-visible .tool-tip {
    visibility: visible;
    -webkit-transition: visibility 30ms ease-in;
    transition: visibility 30ms ease-in;
}

/* View Sites Modal Styles */
.sites_modal__wrapper {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 18%);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
    z-index: 1000;
}

.sites_modal__container {
    width: min(30%, 50%);
    position: fixed;
    background: rgb(255, 255, 255);
    border-radius: 4px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    max-height: 50vh;
}

.modal-header {
    background: #768dd3;
    color: white;
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header h4 {
    margin: 0;
    font-weight: 600;
    font-size: 1.1rem;
}

.close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 1.3rem;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s ease;
}

.close-btn:hover {
    color: #f0f0f0;
}

.modal-body {
    padding: 1.5rem;
    overflow-y: auto;
    flex: 1;
}

.modal-footer {
    border-top: 1px solid #e0e0e0;
    padding: 1rem;
    text-align: right;
}

.btn-close {
    background-color: #768dd3;
    color: white;
    border: none;
    padding: 0.5rem 1.5rem;
    border-radius: 4px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-close:hover {
    background-color: #5a71a8;
}

.sites-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 0;
}

.sites-table thead {
    background-color: #f9f9f9;
    border-top: 1px solid #e7eaec;
}

.sites-table thead th {
    padding: 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #333;
    border-bottom: 1px solid #e7eaec;
    font-size: 0.9rem;
}

.sites-table tbody tr {
    border-bottom: 1px solid #e7eaec;
}

.sites-table tbody tr:hover {
    background-color: #f9f9f9;
}

.sites-table tbody td {
    padding: 0.75rem;
    color: #555;
    font-size: 0.9rem;
}

.empty-state {
    padding: 2rem 1rem;
    background-color: #f9f9f9;
    border-radius: 4px;
    color: #999;
}

.cursor-pointer {
    cursor: pointer;
}
</style>
